import { render, staticRenderFns } from "./SubcategoriesModal.vue?vue&type=template&id=113d443a"
import script from "./SubcategoriesModal.vue?vue&type=script&lang=js"
export * from "./SubcategoriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports